// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-js-account-settings-branding-current-image-module__noImage--_BpB5 {
  color: #D7D7D7;
}
.src-js-account-settings-branding-current-image-module__noImage--_BpB5 i {
  margin-right: 5px;
}`, "",{"version":3,"sources":["webpack://./src/js/account/settings/branding/current-image.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB","sourcesContent":[".noImage {\n  color: #D7D7D7;\n}\n.noImage i {\n  margin-right: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"noImage": `src-js-account-settings-branding-current-image-module__noImage--_BpB5`
};
export default ___CSS_LOADER_EXPORT___;
